

export default{

    name: 'daybook',
    component: () => import(/* webpackChunkName: "daybook" */ '@/modules/daybook/layouts/DayBookLayout.vue'),
    children:[
        {
            path: '',
            name: 'no-entry',
            component: () => import(/* webpackChunkName: "no-entry daybook" */ '@/modules/daybook/views/NoEntrySelected.vue'),
        },
        {
            path: ':id',
            name: 'entry',
            component: () => import(/* webpackChunkName: "no-entry daybook" */ '@/modules/daybook/views/EntryView.vue'),
        },
        {
            path: ':id',
            name: 'users',
            component: () => import(/* webpackChunkName: "no-entry daybook" */ '@/modules/daybook/views/Users.vue'),
        },
        {
            path: ':id',
            name: 'reports',
            component: () => import(/* webpackChunkName: "no-entry daybook" */ '@/modules/daybook/views/Reports.vue'),
        },
        {
            path: ':id',
            name: 'sendx18',
            component: () => import(/* webpackChunkName: "no-entry daybook" */ '@/modules/daybook/views/SendX18.vue'),
        },
        {
            path: ':id',
            name: 'create',
            component: () => import(/* webpackChunkName: "no-entry daybook" */ '@/modules/daybook/views/UserCreate.vue'),
        }
        ,
        {
            path: ':id',
            name: 'fire',
            component: () => import(/* webpackChunkName: "no-entry daybook" */ '@/modules/daybook/views/UserCreateFire.vue'),
        } ,
        {
            path: ':id',
            name: 'edit',
            component: () => import(/* webpackChunkName: "no-entry daybook" */ '@/modules/daybook/views/UserEdit.vue'),
        }
    ]
}